// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_contentSidebarPage__3xl7v {
  position: absolute;
  top: 122px;
  bottom: 65px;
  right: 0;
  width: 0;
  overflow: hidden;
  background: var(--bg-main);
  transition: width ease-in 0.3s;
  z-index: 100;
}
.style_contentSidebarPage__3xl7v h1 {
  width: 100%;
}
.style_contentSidebarPage__3xl7v .style_aside__DF-oy {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
}
.style_contentSidebarPage__3xl7v .style_sidebarItem__b28rx {
  width: 100%;
  display: grid;
  grid-template-columns: 50px 1fr 30px;
  grid-template-rows: 15px 30px;
  align-items: center;
}
.style_contentSidebarPage__3xl7v .style_sidebarItem__b28rx .style_icon__JiSGG {
  font-size: 35px;
}
.style_contentSidebarPage__3xl7v .style_sidebarItem__b28rx .style_icon__JiSGG,
.style_contentSidebarPage__3xl7v .style_sidebarItem__b28rx .style_img__v3m2c {
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(100% - 10px);
  height: calc(100% - 10px);
  grid-row: span 2;
}
.style_contentSidebarPage__3xl7v .style_sidebarItem__b28rx i {
  grid-row: span 2;
}

.style_active__DHvml {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/templates/partials/Sidebar/style.module.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,UAAA;EACA,YAAA;EACA,QAAA;EACA,QAAA;EACA,gBAAA;EACA,0BAAA;EACA,8BAAA;EACA,YAAA;AACJ;AACI;EACI,WAAA;AACR;AAGI;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;AADR;AAII;EACI,WAAA;EACA,aAAA;EACA,oCAAA;EACA,6BAAA;EACA,mBAAA;AAFR;AAIQ;EACI,eAAA;AAFZ;AAKQ;;EAEI,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,wBAAA;EACA,yBAAA;EACA,gBAAA;AAJZ;AAOQ;EACI,gBAAA;AALZ;;AAUA;EACI,WAAA;AAPJ","sourcesContent":[".contentSidebarPage {\n    position: absolute;\n    top: 122px;\n    bottom: 65px;\n    right: 0;\n    width: 0;\n    overflow: hidden;\n    background: var(--bg-main);\n    transition: width ease-in .3s;\n    z-index: 100;\n\n    h1 {\n        width: 100%;\n    }\n\n\n    .aside {\n        display: flex;\n        flex-direction: column;\n        gap: 1rem;\n        padding: 1rem;\n    }\n\n    .sidebarItem {\n        width: 100%;\n        display: grid;\n        grid-template-columns: 50px 1fr 30px;\n        grid-template-rows: 15px 30px;\n        align-items: center;\n\n        .icon {\n            font-size: 35px;\n        }\n\n        .icon,\n        .img {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            \n            width: calc(100% - 10px);\n            height: calc(100% - 10px);\n            grid-row: span 2;\n        }\n\n        i {\n            grid-row: span 2;\n        }\n    }\n}\n\n.active {\n    width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contentSidebarPage": `style_contentSidebarPage__3xl7v`,
	"aside": `style_aside__DF-oy`,
	"sidebarItem": `style_sidebarItem__b28rx`,
	"icon": `style_icon__JiSGG`,
	"img": `style_img__v3m2c`,
	"active": `style_active__DHvml`
};
export default ___CSS_LOADER_EXPORT___;
